import React from 'react';
import { connect } from 'react-redux';
import { ValuesCache } from '@leverege/value-cache';
import { UI } from '@leverege/ui-redux';
import { Config } from '@leverege/plugin';
import { Attributes, EditorUtil } from '@leverege/ui-attributes';
import { Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { ItemDelegate } from '@leverege/molten-core';
import LoadingView from "../../../views/LoadingView.js";
import RelationshipTypeSelector from "./RelationshipTypeSelector.js";
import { jsx as _jsx } from "react/jsx-runtime";
const uiReduxKey = 'relationshipSelector.nextToken';
const {
  t
} = I18N.ns('molten.imagine.attributes.RelationshipSelector');
class RelationshipSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    };
    this.cache = new ValuesCache();
    const {
      groupDelegate
    } = props;
    this.nameAttribute = Attributes.getAttribute('name', groupDelegate.relationship.objectType);
  }
  componentDidMount() {
    const {
      dispatch,
      groupDelegate,
      value
    } = this.props;
    this.loadData();
    if (value != null) {
      dispatch(groupDelegate.item(value).get({
        ttl: 300000
      }));
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      search
    } = this.state;
    const {
      search: pSearch
    } = prevState;
    if (search !== pSearch) {
      this.loadData();
    }
  }
  loadData = () => {
    const {
      dispatch,
      groupDelegate,
      nextToken
    } = this.props;
    const {
      search
    } = this.state;
    const limit = Config.get('RelationshipSetter', 'listLimit', 100);
    // TODO: Can't sort by a keyword field anymore so this is broken
    // const sort = [ {
    //   field : this.nameAttribute.blueprint.field,
    //   missing : '_first',
    //   order : 'asc'
    // } ]
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      if (search && search.length) {
        // try adding a sort to query based on name
        dispatch(groupDelegate.search({
          filter: {
            type: 'groupedText',
            fields: [{
              field: this.nameAttribute.blueprint.field,
              type: 'interfixFinalToken'
            }],
            value: search
          },
          // update to be the same query as the table filter
          limit,
          nextToken
        })).then(({
          nextToken
        }) => {
          dispatch(UI.set(uiReduxKey, !nextToken ? null : nextToken));
        });
      } else {
        dispatch(groupDelegate.search({
          limit,
          nextToken
        })).then(({
          nextToken
        }) => {
          dispatch(UI.set(uiReduxKey, !nextToken ? null : nextToken));
        });
      }
    }, 500);
  };
  onChange = event => {
    const {
      delegate,
      onChange,
      value,
      attribute
    } = this.props;
    const pairingDelegate = delegate.child(attribute.source?.attribute?.path);
    this.setState({
      search: ''
    });
    if (event.value === 'loading') {
      // this is a placeholder element, do nothing
      return;
    }
    if (event.value == null) {
      // This is a removal. We dont have to copy data from parent
      if (value != null) {
        const parentRef = delegate.itemRef();
        const parentKey = attribute?.blueprint?.attribute?.path;
        onChange({
          ...event,
          value: {
            parentRef,
            type: 'remove',
            parentKey
          }
        });
      }
      return;
    }
    const childRef = {
      ...pairingDelegate.relationship.objRef,
      id: event.value
    };
    // const extra = RelationshipUtil.makeCopyEvents( parentRef, attribute, context )

    if (pairingDelegate.relationship.isOneToOne) {
      onChange({
        ...event,
        value: {
          childRef,
          type: 'set'
        }
      });
    } else if (pairingDelegate.relationship.isOneToMany) {
      onChange({
        ...event,
        value: {
          childRef,
          type: 'add'
        }
      });
    }
  };
  onChangeFilter = event => {
    const {
      value
    } = event;
    this.setState({
      search: value
    });
  };
  render() {
    const {
      allowed,
      attribute,
      usage,
      textVariant,
      editable,
      value,
      parentItems,
      item,
      loading,
      showFilter,
      groupDelegate,
      eventData,
      nextToken
    } = this.props;
    const {
      search
    } = this.state;
    const {
      filteredItems
    } = parentItems || {};
    const itemLoadDone = value && !groupDelegate.item(value).isLoading();
    const items = filteredItems?.filter(i => !!i) || [];
    // We are loading if:
    // 1) we have a value and we have not loaded the item for it yet
    // 2) we have not loaded our list yet
    // 3) we dont have items and we are loading
    if (value && !itemLoadDone && item == null || groupDelegate.getStatus() == null || !showFilter && (items == null || items.length === 0) && loading) {
      return /*#__PURE__*/_jsx(LoadingView, {
        inline: true
      });
    }
    if (!showFilter && (items == null || items.length === 0)) {
      return /*#__PURE__*/_jsx(Text, {
        variant: textVariant,
        children: t('noOptions')
      });
    }
    const values = this.cache.calc('items', items => {
      let hasValue = value == null;
      const r = items == null ? [] : items.map(item => {
        hasValue = hasValue || item.id === value;
        return {
          name: this.nameAttribute.get(item) || item.name || item.id,
          value: item.id
        };
      });
      if (!hasValue) {
        r.unshift({
          name: this.nameAttribute.get(item) || value,
          value
        });
      }
      r.unshift({
        name: t('notSet'),
        value: null
      });
      if (nextToken) {
        r.push({
          name: t('loading', 'Loading more'),
          value: 'loading'
        });
      }
      return r;
    }, items, item, value, nextToken);

    // add a loading more element to the bottom
    if (!editable || !allowed) {
      const c = values.find(item => item.value === value);
      // TODO: CHANGE TO GET VARIANT
      return /*#__PURE__*/_jsx(Text, {
        variant: textVariant,
        children: c ? c.name : value
      });
    }
    return /*#__PURE__*/_jsx(RelationshipTypeSelector, {
      search: search,
      attribute: attribute,
      variant: EditorUtil.getVariant(usage, 'parent', 'editor'),
      onChangeFilter: this.onChangeFilter,
      onChange: this.onChange,
      value: value,
      values: values,
      eventData: eventData,
      nameAttribute: this.nameAttribute
    });
  }
}
export default connect((state, props) => {
  const {
    groupDelegate,
    value
  } = props;
  return {
    item: ItemDelegate.getItem(value),
    parentItems: groupDelegate.getList(state),
    loading: groupDelegate.isLoading(state),
    currentLoading: groupDelegate.isLoading(state),
    allowed: groupDelegate.canList(state, true),
    nextToken: UI.get(state, uiReduxKey)
  };
})(RelationshipSelector);